<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">业务员日报表</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="统计月份" prop="usertype">
              <el-date-picker
                  v-model="queryForm.month"
                  type="month"
                  placeholder="选择月">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="业务员" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入业务员名称"/>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <!--<el-col :span="5">
            <el-form-item label="所属分站" prop="businesstype">
              <el-select v-model="queryForm.businesstype" clearable placeholder="请选择所属分站">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>-->

          <el-col :span="5">
            <el-form-item label="上级业务员" prop="upBusinessName">
              <el-input v-model="queryForm.upBusinessName" placeholder="请输入上级业务员"/>
            </el-form-item>
          </el-col>

          <el-col :span="8" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
              <el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="totalData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="businessDayTotal" label="合计" />
        <el-table-column prop="businessDayDataList" v-for="(item, index) in mouths" :key="index" :label="item.orderDay">
          <template slot-scope="scope">
            <span>{{getOrderNum(scope.row.businessDayDataList, item.orderDay)}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column label="序号" >
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="registerTime" label="注册时间" width="100"/>
        <el-table-column prop="salemanName" label="业务员" />
        <el-table-column prop="upSalemanName" label="上级业务" />
        <el-table-column prop="businessNums" label="商家数" />
        <el-table-column prop="shopNums" label="店铺数" />
        <el-table-column prop="businessMoneyTotal" label="商家总余额"/>
        <el-table-column prop="totalMoneyOrders" label="合计" />
        <el-table-column prop="businessDayDatas" v-for="(item, index) in mouths" :key="index" :label="item.orderDay">
          <template slot-scope="scope">
            <span>{{getOrderNum(scope.row.businessDayDatas, item.orderDay)}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {getStrEndWithNumbers} from "../../lib/utils";
import {querySalemanselfDataReport, querySalemanSelfDataTotalReport} from "../../api/b2cbusiness/b2c_saleman";

export default {
  name: "SalemanChartDayReport",
  mixins: [MixinCUD],
  data(){
    return {
      totalData:[],
      tableData:[],
      options:[
        {
          value: "总站"
        },
        {
          value: "分站"
        }
      ],
      queryFormRefName:"queryForm",
      queryForm:{
        month: new Date(),
      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      mouths: [
        {
          orderDay: 1,
          dayValue: "day_1"
        },
        {
          orderDay: 2,
          dayValue: "day_2"
        },
        {
          orderDay: 3,
          dayValue: "day_3"
        },
        {
          orderDay: 4,
          dayValue: "day_4"
        },
        {
          orderDay: 5,
          dayValue: "day_5"
        },
        {
          orderDay: 6,
          dayValue: "day_6"
        },
        {
          orderDay: 7,
          dayValue: "day_7"
        },
        {
          orderDay: 8,
          dayValue: "day_8"
        },
        {
          orderDay: 9,
          dayValue: "day_9"
        },
        {
          orderDay: 10,
          dayValue: "day_10"
        },
        {
          orderDay: 11,
          dayValue: "day_11"
        },
        {
          orderDay: 12,
          dayValue: "day_12"
        },
        {
          orderDay: 13,
          dayValue: "day_13"
        },
        {
          orderDay: 14,
          dayValue: "day_14"
        },
        {
          orderDay: 15,
          dayValue: "day_15"
        },
        {
          orderDay: 16,
          dayValue: "day_16"
        },
        {
          orderDay: 17,
          dayValue: "day_17"
        },
        {
          orderDay: 18,
          dayValue: "day_18"
        },
        {
          orderDay: 19,
          dayValue: "day_19"
        },
        {
          orderDay: 20,
          dayValue: "day_20"
        },
        {
          orderDay: 21,
          dayValue: "day_21"
        },
        {
          orderDay: 22,
          dayValue: "day_22"
        },
        {
          orderDay: 23,
          dayValue: "day_23"
        },
        {
          orderDay: 24,
          dayValue: "day_24"
        },
        {
          orderDay: 25,
          dayValue: "day_25"
        },
        {
          orderDay: 26,
          dayValue: "day_26"
        },
        {
          orderDay: 27,
          dayValue: "day_27"
        },
        {
          orderDay: 28,
          dayValue: "day_28"
        },
        {
          orderDay: 29,
          dayValue: "day_29"
        },
        {
          orderDay: 30,
          dayValue: "day_30"
        },
        {
          orderDay: 31,
          dayValue: "day_31"
        }
      ]
    }
  },
  mounted() {
    this.getData();
  },
  computed:{
    getOrderNum(){
      return function (datas, dayKey) {
        for (let item in datas){
          if (datas[item].orderDay == dayKey){
            return datas[item].orderNums;
          }
        }
      }
    },
  },
  methods: {
    getData(){
      querySalemanSelfDataTotalReport(this.queryForm).then(res=>{
        if (res.success) {
          this.totalData = res.data;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
      querySalemanselfDataReport(this.queryForm, this.pagination).then(res=>{
        if (res.success) {
          console.log(res.data.records);
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
          if (this.tableData.length > 0){
            this.mouths = this.tableData[0].businessDayDatas;
          }
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
